import { forwardRef, type AnchorHTMLAttributes, type ButtonHTMLAttributes, type PropsWithChildren } from 'react'

type ButtonVariant = 'primary' | 'secondary' | 'ghost'

type SharedProps = PropsWithChildren<{
  variant?: ButtonVariant
  className?: string
}>

const variantClass: Record<ButtonVariant, string> = {
  primary: 'button-primary',
  secondary: 'button-secondary',
  ghost: 'button-ghost',
}

function cx(...parts: Array<string | undefined>) {
  return parts.filter(Boolean).join(' ')
}

export const Button = forwardRef<HTMLButtonElement, SharedProps & ButtonHTMLAttributes<HTMLButtonElement>>(
  function Button({ variant = 'primary', className, children, type = 'button', ...props }, ref) {
    return (
      <button ref={ref} type={type} className={cx(variantClass[variant], className)} {...props}>
        {children}
      </button>
    )
  },
)

export function ButtonLink({
  variant = 'primary',
  className,
  children,
  ...props
}: SharedProps & AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <a className={cx(variantClass[variant], className)} {...props}>
      {children}
    </a>
  )
}
